import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ChartsModule } from '@cpd-app/shared-module/components/charts/charts.module';
import { SharedModule } from '@cpd-app/shared-module/shared.module';

import { OccupationFavoriteButtonComponent } from './occupation-favorite-button/occupation-favorite-button.component';
import { OccupationCardComponent } from './occupation-card/occupation-card.component';
import { OccupationListComponent } from './occupation-list/occupation-list.component';
import { OccupationQuickMatchCardComponent } from './occupation-quick-match-card/occupation-quick-match-card.component';
import { OccupationQuickMatchListComponent } from './occupation-quick-match-list/occupation-quick-match-list.component';
import { OccupationScoresDisplayComponent } from './occupation-scores-display/occupation-scores-display.component';
import { OccupationScoresInfoComponent } from './occupation-scores-info/occupation-scores-info.component';

@NgModule({
  imports: [CommonModule, ChartsModule, ScrollingModule, SharedModule],
  declarations: [
    OccupationCardComponent,
    OccupationListComponent,
    OccupationScoresDisplayComponent,
    OccupationQuickMatchListComponent,
    OccupationQuickMatchCardComponent,
    OccupationScoresInfoComponent,
    OccupationFavoriteButtonComponent
  ],
  exports: [
    OccupationCardComponent,
    OccupationListComponent,
    OccupationQuickMatchListComponent,
    OccupationQuickMatchCardComponent,
    OccupationScoresDisplayComponent,
    OccupationScoresInfoComponent
  ]
})
export class OccupationSharedModule {}
